import { useEffect, useRef, useState } from "react"
import { CustomInput } from "../../../form/CustomInput"
import { palette } from "../../../assets/theme/theme";
import { useFormType } from "../../../form/hooks/useForm";
import { EntityConfig } from "../../../types/EntityConfig";




export default function FiltersPopup({ isOpen, headCells, filterForm }: {isOpen: boolean, headCells: EntityConfig, filterForm: useFormType}) {

    const [processedHeadCells, setProcessedHeadCells] = useState<any[] | null>(null);


    useEffect(() => {
        processHeadCellsForBooleanValues();
    }, [headCells])

    const processHeadCellsForBooleanValues = () => {
        const newHeadCells: any[] = [];
        headCells.forEach((hc: any) => {
            const newHc = { ...hc };
            if (newHc.type == 'boolean') {
                newHc.type = 'select'
                newHc.options = {
                    'defaultOptions': [true, false],
                    labelFunction: (option : any) => option? 'Sim' : 'Não'  
                };
            }
            newHeadCells.push(newHc);
        })

        setProcessedHeadCells(newHeadCells);
    }


    const buildGetterFunction = (tc: any) => {
        return tc.options?.getter;
    }


    return (< >
        {isOpen ? <div className="block bg-white z-50 border-2 border-rodrimaq-red-medium rounded">
            <div className="p1">
            {
                processedHeadCells?.filter((hc) => hc.filterable).length ?
                    processedHeadCells?.filter((hc) => hc.filterable).map((hc, idx) => {
                        return (
                        <div className="text-xs" key={`${hc.id}-${idx}`}>
                            <CustomInput
                                filterMode={true}
                                inputConfiguration={hc}
                                getter={buildGetterFunction(hc)}
                                form={filterForm}
                                />
                        </div>)
                    }) : <div style={{ margin: 10 }}><span style={{ color: palette.gray.medium, padding: 10 }}>Nenhum filtro seleccionado</span></div>

            }
            </div>
            </div> : null}</>
    )

}